import React, {useRef, useEffect, useState, PropsWithChildren} from 'react'

import './index.scss'

type EndlessListPropsType = {
    onTouchBottom?: () => void,
    loading?: boolean,
    noMore?: boolean,
    tips?: React.ReactElement,
    distance?: number
}

const EndlessList = (props: PropsWithChildren<EndlessListPropsType>) => {
    const ref = useRef<HTMLDivElement | null>(null)
    const distance = props.distance || 20
    const onScroll = () => {
        if (!ref.current) return
        const scrollHeight = ref.current.scrollHeight
        const scrollTop = ref.current.scrollTop
        const height = ref.current.clientHeight
        if (height + scrollTop >= scrollHeight - distance) {
            props.onTouchBottom && props.onTouchBottom()
        }
    }
    return (
        <div ref={ref} className={'list'} onScroll={onScroll}>
            {props.children}
            <Tips {...props} />
        </div>
    )
}

export default EndlessList

function Tips({tips, loading, noMore}: any) {
    const [hasLoad, setHasLoad] = useState(false)
    useEffect(() => {
        loading && !hasLoad && setHasLoad(true)
    }, [loading])
    const defaultEl = (
        <>
            {
                loading
                    ? <div className={'noMore'}>加载中……</div>
                    : noMore && <div className={'noMore'}>--数据已全部加载--</div>
            }
        </>
    )
    return (
        <>{tips || defaultEl}</>
    )
}
